module.exports = __webpack_public_path__ + "static/media/rover-navigation.jpg";